const SubmitButton =  ({ onClick, disabled, loading }) => {
    return (
        <button
      type="submit"
      disabled={disabled}
      onClick={onClick}
      className={`border-[2px] px-4 py-2 mt-4 w-full ${
        loading ? "bg-gray-400 shadow-none cursor-progress" : ""
      }`}
    >
      {loading ? (
        <div
          className="h-7 w-7 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
          role="status"
        >
          <span className="!absolute !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
            Submitting...
          </span>
        </div>
      ) : (
        "Submit"
      )}
    </button>
    );
};
export default SubmitButton;